import * as React from "react";
const HeaderContext = React.createContext({
  headerBottomHeight: 0,
  headerHeight: 0,
  isHeaderHidden: false,
  setHeaderBottomHeight: (
    /* istanbul ignore next */
    () => null
  ),
  setHeaderHeight: (
    /* istanbul ignore next */
    () => null
  ),
  toggleHeaderHidden: (
    /* istanbul ignore next */
    () => null
  )
});
const HeaderProvider = (props) => {
  const [headerBottomHeight, setHeaderBottomHeight] = React.useState(0);
  const [headerHeight, setHeaderHeight] = React.useState(0);
  const [isHeaderHidden, toggleHeaderHidden] = React.useState(false);
  return /* @__PURE__ */ React.createElement(
    HeaderContext.Provider,
    {
      value: React.useMemo(
        () => ({
          headerBottomHeight,
          headerHeight,
          isHeaderHidden,
          setHeaderBottomHeight,
          setHeaderHeight,
          toggleHeaderHidden
        }),
        [headerBottomHeight, headerHeight, isHeaderHidden]
      )
    },
    props.children
  );
};
export {
  HeaderContext,
  HeaderProvider
};
